<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  watch: {
    '$i18n.locale'() {
      this.updateTitle()
    }
  },
  mounted() {
    this.updateTitle()
  },
  methods: {
    updateTitle() {
      const title = this.$t('common.siteTitle')
      document.title = title
    }
  }
}
</script>

<style>
html,body{
  height: 100%;
  margin: 0;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  height: 100%;
}
</style>